export default __webpack_public_path__ + "static/media/fastingtime@2x.9c89a5c5.jpg";